/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectionDashboard200,
  GetApiV1ExamCorrectionDashboard400,
  GetApiV1ExamCorrectionDashboard401,
  GetApiV1ExamCorrectionDashboard500,
  GetApiV1ExamCorrectionDashboardQueryParams,
  GetApiV1ExamCorrectionDashboardQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionDashboard.ts";
import { correctionDashboardItemRepositoryResponsePaginatedResponseSchema } from "../correctionDashboardItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamCorrectionDashboardQueryParamsSchema = z
  .object({
    SeeOnlyOwnExamItem: z.optional(z.boolean()),
    FilterStartDate: z.optional(z.string().datetime()),
    FilterEndDate: z.optional(z.string().datetime()),
    FilterDisciplineId: z.optional(z.coerce.number().int()),
    OnlyShowEnglishCourse: z.optional(z.boolean()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamCorrectionDashboardQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectionDashboard200Schema = z.lazy(
  () => correctionDashboardItemRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ExamCorrectionDashboard200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectionDashboard400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionDashboard400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectionDashboard401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionDashboard401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectionDashboard500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionDashboard500>;

export const getApiV1ExamCorrectionDashboardQueryResponseSchema = z.lazy(
  () => getApiV1ExamCorrectionDashboard200Schema,
) as unknown as ToZod<GetApiV1ExamCorrectionDashboardQueryResponse>;
